import { z } from 'zod';

export const requestPhoneCodeResponseSchema = z.object({
  success: z.literal(true),
});
